import React from 'react';

import Image from '../../Commons/Image/Image';
import ARCOS from '../../../assets/swiss-medical-center/centro_arcos.jpg';

import styles from './SwissMedicalArcos.module.scss';

const SwissMedicalArcos = () => {
  return (
    <div className={styles.swiss_medical_arcos}>
      <h3>Swiss Medical Center de los Arcos</h3>
      <p>
        <strong className={styles.swiss_medical_arcos__redText}>Dirección:</strong> Guatemala 5455,
        CABA
      </p>
      <p>
        <strong className={styles.swiss_medical_arcos__redText}>Turnos:</strong> 0810-333-8876
      </p>
      <Image
        src={ARCOS}
        alt='Sede Arcos'
        title='Arcos'
        classes={styles.swiss_medical_arcos__image}
      />
      <p>
        <strong className={styles.swiss_medical_arcos__redText}>Especialidades medicas</strong>
      </p>
      <ul>
        <li>Cardiología</li>
        <li>Cirugía hepatica</li>
        <li>Cirugía plástica Reparadora</li>
        <li>Clínica médica</li>
        <li>Coloproctología</li>
        <li>Cirugía Cabeza y Cuello</li>
        <li>Gastroenterología</li>
        <li>Ecografía general</li>
        <li>Hematología</li>
        <li>Hepatología</li>
        <li>Infectología</li>
        <li>Tratamiento del dolor</li>
        <li>Traumatología</li>
        <li>Traumatología Infantil</li>
      </ul>
      <p>
        <strong className={styles.swiss_medical_arcos__redText}>
          Especialidades médicas neurológicas
        </strong>
      </p>
      <ul>
        <li>Epilepsia</li>
        <li>Movimientos anormales</li>
        <li>Neurocirugía adultos</li>
        <li>Neurocirugía pediátrica</li>
        <li>Neuroinmunología</li>
        <li>Neurología cognitiva y neuropsicología</li>
        <li>Neurología vascular</li>
        <li>Patologías neuromusculares</li>
        <li>Psiquiatría</li>
      </ul>
      <p>
        <strong className={styles.swiss_medical_arcos__redText}>Estudios de diagnóstico</strong>
      </p>
      <ul>
        <li>Electroencefalografía</li>
        <li>Electromiografía</li>
        <li>Evaluaciones cognitivas</li>
        <li>Evaluaciones neurolingüísticas</li>
        <li>Potenciales evocados</li>
        <li>Velocidades de conducción nerviosa</li>
      </ul>
    </div>
  );
};

export default SwissMedicalArcos;
